/**
 * @flow
 */

import {
  ON_MY_TICKETS_CURRENT_MOUNT_SUCCESS,
  ON_MY_TICKETS_PAST_MOUNT_SUCCESS,
  CANCEL_ORDER_SUCCESS,
  ON_MY_TICKETS_MOUNT,
  PAGINATION_MORE_ORDERS
} from '../actions';

const initialState = {
  current: {},
  past: {},
  listings: {}
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case PAGINATION_MORE_ORDERS:
      const current = action.payload.isCurrentOrPast === 'current';
      const past = action.payload.isCurrentOrPast === 'past';

      return Object.assign({}, state, {
        current: current ? {} : state.current,
        past: past ? {} : state.past
      });

    case ON_MY_TICKETS_CURRENT_MOUNT_SUCCESS:
      if (!action.payload.listings) return state;

      const currentListingsById = action.payload.listings.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});

      return Object.assign({}, state, {
        current: action.payload,
        listings: Object.assign({}, state.listings, {
          ...currentListingsById
        })
      });

    case ON_MY_TICKETS_PAST_MOUNT_SUCCESS:
      if (!action.payload.listings) return state;

      const pastListingsById = action.payload.listings.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});

      return Object.assign({}, state, {
        past: action.payload,
        listings: Object.assign({}, state.listings, {
          ...pastListingsById
        })
      });

    case CANCEL_ORDER_SUCCESS:
      const updatedCurrentTickets = state.current.tickets.map(ticket => {
        if (ticket.id === action.ticketId) {
          ticket.state = 'cancelled';
        }
        return ticket;
      });

      return Object.assign({}, state, {
        current: Object.assign({}, state.current, {
          tickets: updatedCurrentTickets
        })
      });

    case ON_MY_TICKETS_MOUNT:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/my-tickets/reducers/my-tickets.js